export default "__VITE_ASSET__aa5716c9__"